<template>
  <div class="search-box">
    <div class="ipt-box">
      <button
        type="button"
        class="selectInput"
        @click="openCity"
      >{{ selectCity }}</button>
      <div class="mask-box" />
    </div>
  </div>
</template>

<script setup>
defineOptions({name: 'SelectCity'});

defineProps({
  selectCity: {
    type: String,
    default: '请选择'
  }
});

const emit = defineEmits(['openCity']);

function openCity () {
  emit('openCity');
}
</script>
<style scoped>

.search-box {
  height: 100%;
  width: 38%;
  background: transparent;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

}
.search-box > .ipt-box {
  width: 100%;
  position: relative;
  height: 38px;
  border: 1px solid var(--border-strong);
  border-right: none;
  border-radius: 8px 0 0 8px;
  background: var(--surface-soft);
  padding-top: 0;
  box-sizing: border-box;
  overflow: hidden;
}
.search-box > .ipt-box:after {
  content: '';
  position: absolute;
  top: 9px;
  right: 0;
  width: 1px;
  height: 20px;
  background: var(--border-strong);
}
.selectInput {
  display: block;
  width: 100%;
  padding: 0 10px 0 12px;
  border: none;
  outline: none;
  border-radius: 8px 0 0 8px;
  box-sizing: border-box;
  font-size: 14px;
  font-family: inherit;
  background: var(--surface-soft);
  color: var(--text-main);
  line-height: 36px;
  height: 36px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
  cursor: pointer;
  -webkit-appearance: none;
  appearance: none;
}
input::-webkit-clear {
  display: none;
}
.search-box > .ipt-box > .mask-box {
  display: none;
}
</style>
